<template>
  <v-container>
    <v-col class="d-flex ssh-wrapper" cols="12" sm="12" style='z-index:10000'>
      <v-select
        item-text="Title"
        item-value="Id"
        :items="sshKeys"
        v-model="selectedSSHKey"
        label="Select SSH key"
        append-icon="fas fa-caret-down"
        @change="onSelectedSSHKey()"
        hide-details
      ></v-select>
    </v-col>
    <v-col class="d-flex ssh-hint-wrapper" cols="12" sm="12" v-if="sshKeys.length === 0">
      <p class="ssh-hint">You have no SSH keys, <a class="create-ssh-key-link" @click="redirectToSSHSettings()">create a new one</a>!</p>
    </v-col>
  </v-container>
</template>

<script>
export default {
	data: () => ({
    selectedSSHKey: ""
  }),
  props: ['sshKeys'],
  methods: {
    onSelectedSSHKey() {
      this.$emit("selectedSSHKey", this.selectedSSHKey);
    },
    redirectToSSHSettings() {
      this.$router.push("/settings/ssh");
    }
  }
}
</script>

<style scoped>
.ssh-hint-wrapper {
  margin-top: -15px;
}
.ssh-hint, .forgot-psw-link  {
  font: 0.75rem "Montserrat";
  text-decoration: none;
  color: #828282;
  margin-bottom: 0;
}
.create-ssh-key-link {
  color: #881E98;
  font-weight: bold;
}
</style>